import React from 'react';
import { useIntl } from 'react-intl';
import AccionaBigButton from '../../../components/AccionaBigButton';
import { useNavigate, useParams } from 'react-router-dom';

const Home = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-6">
        <AccionaBigButton
          icon="no_hood_device"
          id="thermalcontrol"
          onClick={() => navigate(`/app/project/${id}/strength/thermalControl`)}
          msg={intl.formatMessage({ id: `button.thermalcontrol` })}
        />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-6">
        <AccionaBigButton
          icon="hooded_device"
          id="hooded"
          onClick={() => navigate(`/app/project/${id}/strength/hoodedControl`)}
          msg={intl.formatMessage({ id: `button.hooded` })}
        />
      </div>
    </div>
  );
};

export default Home;
